module.exports = __webpack_public_path__ + "img/done.e34be2cb.svg";